import React from 'react';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';

const BrowseTopDrugs = ({ drugs, heading, i18n }) => {
  const getTopDrugs = language =>
    drugs.map((item, id) => (
      <li key={id}>
        <a
          href={`${_.withLocale(language, '/prescription')}/${item.seoName}`}
          title={item.name}
          aria-label={`${item.name} Drug Coupons Prices`}
        >
          {item.name}
        </a>
      </li>
    ));

  return (
    <div className="browse-top-drugs-wrapper">
      <section className="browse-top-drugs">
        <article>
          <h2 className="browse-top-drugs-heading">{heading}</h2>
          <ul>{getTopDrugs(i18n.language)}</ul>
        </article>
      </section>
    </div>
  );
};

export default withTranslation()(BrowseTopDrugs);
